import { createRouter, createWebHistory } from 'vue-router';
import { authRoutes } from '@/modules/auth/routes/index';
import { ewwmsRoutes } from '@/modules/ewwms/routes/index';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...authRoutes,
    ...ewwmsRoutes,
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/shared/ui/Einstellungen.vue'),
      meta: { requiresEwerpAdmin: true },
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/shared/ui/NotFound.vue') },
  ],
});

router.beforeEach(async (to) => {
  if (!to.meta.requiresEwerpAdmin) {
    return true;
  }

  const { useAuthStore } = await import('@/modules/auth/stores/authStore');
  const authStore = useAuthStore();
  await authStore.initAuth();

  return authStore.isEwerpAdmin ? true : { name: 'ewwms.bestellungen' };
});

export default router;
